import { VendorContainer } from '../../../containers/VendorContainer'

const Vendors = () => {
  return <VendorContainer />
}

export default Vendors
